/**
 * DTO object for creation of FeedbackHistory.
 */
export class FeedbackHistoryDto {
  id: number;
  reviewId: number;
  userName: string | null;
  action: string;
  date: Date;
}
